<template lang="pug">
    section#inscreva
        div.wrapper
            div.conteudo
                //- p
                    |Consulte seu polo
                //-     span A UniFAEL!
                a(href="#", target="_blank").button.disabled INSCRIÇÕES AINDA NÃO LIBERADAS
</template>

<script>
export default {
    name: "section-inscreva"
}
</script>

<style lang="stylus" scoped src="./Inscreva.styl"></style>
